import type { QueryFunctionContext } from '@tanstack/react-query';
import { request } from '@utilities/graphQLClient';
import { gql } from 'graphql-request';
import type { PrimaryCountryISO } from '@/constants/countries';

export interface Industry {
  label: string;
  slug: string;
  companyCount: number;
  children: string[];
}

export interface IndustryResponse {
  slug: string;
  companyCount: number;
  name: string;
  friendlyName: string;
  level: number;
  id: string;
  children: Array<{ id: string }>;
}

interface QueryResponse {
  Industries: Array<IndustryResponse>;
}

export const MINIMUM_COMPANIES = 5;

export const GET_INDUSTRY_QUERY_KEY = 'get-industries';

async function fetchIndustries({
  queryKey: [_, country],
}: QueryFunctionContext<[string, PrimaryCountryISO]>): Promise<
  QueryResponse | undefined
> {
  try {
    return await request<QueryResponse>(
      gql`
        query industryTree($market: String!) {
          Industries(limit: 300) {
            slug
            companyCount(countryIso2: $market)
            name
            friendlyName
            level
            id
            children {
              id
            }
          }
        }
      `,
      {
        market: country.toUpperCase(),
      }
    );
  } catch (e) {
    if (e instanceof Error) {
      console.error(e.message);
      throw new Error(e.message);
    }
  }
}

export default fetchIndustries;
